import Client from "./Client";
// import RequestList from "./RequestList";

const Service = {
    url: 'admin/tickets',
    getDefault(){
        return {
            ticket_number : undefined,
            subject : undefined,
            department : undefined,
            status : undefined,
            description : undefined,
            created_at : undefined,
            updated_at : undefined,
            closed_at : undefined
        }
    },
    getDefaultTicketActivity(){
        return {
            description : undefined,
            user_visibility : true,
            created_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params user
     * @return Request Promise
     **/
    async create(ticket) {
        return await Client.post(`${this.url}`, ticket);
    },

    /**
     * @params user
     * @return Request Promise
     **/
    async details(ticket_number) {
        return await Client.get(`${this.url}/${ticket_number}`);
    },
    /**
     * @params user
     * @return Request Promise
     **/
    async createActivity(ticket, ticketActivity) {
        return await Client.post(`${this.url}/${ticket.ticket_number}/activities`, ticketActivity);
    },
    /**
     * @params user
     * @return Request Promise
     **/
    async ongoingTicket(ticket_number) {
        return await Client.post(`${this.url}/${ticket_number}/ongoing`);
    },
}

export default Service